import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../app.component";
import {Batiment} from "../Models/Batiment";
import {cloneDeep} from "lodash";

@Component({
	selector: 'app-partenaires',
	templateUrl: './partenaires.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./partenaires.component.less']
})
export class PartenairesComponent implements OnInit {
	globalTxt: any = "";
	modalsTxt: any;
	textes: any = "";
	partners: any[] = [];
	batiment!: Batiment;
	token = JSON.parse(localStorage.getItem("token")!);
	typeRenovation: string = localStorage.getItem("RENOVATION")!;

	constructor(
		public app: AppComponent
	) {
	}

	ngOnInit(): void {
		// Remove modalOpen in localStorage
		localStorage.removeItem('modalOpen');

		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		this.batiment = JSON.parse(localStorage.getItem("BATIMENT")!);

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					let partners: any[] = this.textes.partnersList;
					partners.forEach((partner: any) => {
						partner.selected = false;
						partner.show = this.filterPartners(partner);
					});

					this.partners = partners.filter((partner: any) => partner.show);
					console.log('this.partners =>', this.partners);
				});
		});

		// Get the modal texts
		this.app.dataInitService.getModalTextsOnce(modalsTxt => {
			this.modalsTxt = modalsTxt;
		});
	}

	filterPartnerByDepartement(partner: any): boolean {
		return partner.departements!.indexOf(this.batiment.cp.substring(0, 2)) != -1 || !partner.departements;
	}

	filterPartnerByRefId(partner: any): boolean {
		return partner.showInRefIds.indexOf(this.token?.refId) != -1;
	}

	filterPartnerByTypeTravaux(partner: any): boolean {
		const renovationKey = this.app.sharedToolsService.getRenovationKeyByValue(this.typeRenovation);
		return partner.typeTravaux.indexOf(renovationKey) !== -1;
		//return partner.typeTravaux.indexOf(this.typeRenovation) != -1;
	}

	filterPartners(_partner: any): boolean {
		return this.filterPartnerByDepartement(_partner) && this.filterPartnerByRefId(_partner) && this.filterPartnerByTypeTravaux(_partner);
	}

	onSubmit(partnerSelected: any = null): void {
		let partnersSelected: any[] = [];

		if (partnerSelected) {
			partnersSelected.push(partnerSelected);
		} else {
			partnersSelected = this.partners.filter((partner: any) => partner.selected);
		}

		console.log('onSubmit partnersSelected =>', partnersSelected);

		if (partnersSelected.length == 0) {
			this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalNoPartnerSelected, 'alert', '',
				() => {
				},
				() => {
				});

			return;
		}

		let listEmails: string[] = [];
		partnersSelected.forEach((partner: any) => {
			var emails = partner.email.split(';');

			for (var j = 0; j < emails.length; j++) {
				listEmails.push(emails[j]);
			}
		});

		// Replace all occurrences of ##PARTNER_NAME## in the text
		let modalTextDef = this.modalsTxt.modalAcceptContactPartner.replace(/##PARTNER_NAME##/g, partnersSelected[0].title);

		this.app.confirmDialogService.confirmThis('', modalTextDef, 'confirm', 'acceptContactPartner',
			() => {
				this.sendEmail(listEmails, parseInt(this.batiment.simulationId!));
			},
			() => {
			});
	}

	sendEmail(_listEmails: string[], _simulationId: number): void {
		this.app.apiToolsService.sendMailPdfPartners(_listEmails, _simulationId).subscribe(
			res => {
				console.log("sendMailPdfPartners res => ", res);

				this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSendMailPartnerOk, "alert", "", () => {
					return;
				}, () => {
					return;
				});
			},
			err => {
				console.log("sendMailPdfPartners error => ", err);

				this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalResultKo, "alert", "", () => {
					return;
				}, () => {
					return;
				});
			}
		)
	}
}
